App.Receiving = (function () {
  var initReceiveItem = function() {
    // hook up the item location actions
    App.ItemLocation.initActions();
  }
  return {
    initReceiveItem: initReceiveItem
  }
})();
